<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss" scoped>
@use '@vemedia/bcn-components/scss/responsive' as *;
</style>
